<template lang="pug">
.box
    b-modal(
        v-model="showSendFinanceInvoiceModal",
        has-modal-card,
        full-screen,
        destroy-on-hide
        trap-focus,
        aria-role="dialog",
        aria-modal)
        template(#default="props")
            SendFinanceInvoiceModal(:data="activeTab === 0 ? formDataArray.map(f => ({...f, ...formData})) : [formData]", @close="props.close")

    ValidationObserver(v-slot="{ handleSubmit }", ref="form")
        .label Rechnungsdetails
        .label.is-small Empfänger
        b-tabs.margin-top(type="is-boxed" v-model="activeTab")
            b-tab-item(label="Eigentümer", icon="domain")
                .overflow-y
                    b-table(
                        :data="owners",
                        default-sort-direction="asc",
                        :checked-rows.sync="selectedOwners",
                        checkable)
                        b-table-column(
                            field="fullName",
                            label="Eigentümer",
                            v-slot="props")
                            | {{ props.row.fullName }}
                        b-table-column(
                            field="fullName",
                            label="Umsatzsteuer",
                            v-slot="props")
                            b-icon(v-if="!props.row.noTax" icon="check" type="is-success")
                            template(v-else)
                                | {{ '-' }}
                        b-table-column(label="Objekte", v-slot="props")
                            a(v-for="r, idx in props.row.rentObjects" @click="$router.push('/data/rent-objects/edit/' + r.id)") {{ r.code }}{{ idx !== props.row.rentObjects.length - 1 ? ', ' : '' }}
            b-tab-item(label="Gast", icon="account-outline")
                b-field(label="Suche", label-position="on-border")
                    b-input(v-model="searchString")
                .overflow-y
                    b-table(
                        :data="searchResults",
                        default-sort-direction="asc",
                        :selected.sync="selectedCustomer",
                        hoverable)
                        b-table-column(
                            field="lastName",
                            label="Nachname",
                            sortable,
                            v-slot="props")
                            | {{ props.row.lastName }}
                        b-table-column(
                            field="firstName",
                            label="Vorname",
                            sortable,
                            v-slot="props")
                            | {{ props.row.firstName }}
                        b-table-column(
                            field="address.city",
                            label="Stadt",
                            sortable,
                            v-slot="props")
                            | {{ props.row.address.city }}
                        b-table-column(
                            field="address.email",
                            label="E-Mail",
                            sortable,
                            v-slot="props")
                            | {{ props.row.address.email }}

        .margin-top
        v-date-picker(
            :columns="2",
            :input-debounce="100",
            :value="formData.invoiceDate")
            template(v-slot="{ inputValue, togglePopover }")
                b-field(label="Rechnungsdatum", label-position="on-border")
                    input.input(
                        :value="inputValue",
                        @click="togglePopover({ inputDebounce: 100, placement: 'auto-start' })")
        b-field(label="Rechnungbeschreibung", label-position="on-border")
            b-input(type="textarea", v-model="formData.description")

        .spacer.md
        .label Einträge
        .inovice-item(v-for="(item, index) in formData.items")
            .invoice-field-group
                ValidationProvider(
                    name="Anzahl",
                    rules="required",
                    v-slot="{ errors, valid }")
                    b-field(
                        label="Anzahl",
                        label-position="on-border",
                        :type="{ 'is-danger': errors[0] }",
                        :message="errors")
                        b-input(
                            :value="item.count",
                            @input="(e) => updatePrice(item.price, e, item)",
                            style="width: 100px")
                ValidationProvider(
                    name="Einheit",
                    rules="required",
                    v-slot="{ errors, valid }")
                    b-field(
                        label="Einheit",
                        label-position="on-border",
                        :type="{ 'is-danger': errors[0] }",
                        :message="errors")
                        b-input(v-model="item.unit", style="width: 100px")
                ValidationProvider(
                    name="Bezeichnung",
                    rules="required",
                    v-slot="{ errors, valid }")
                    b-field(
                        label="Bezeichnung",
                        label-position="on-border",
                        :type="{ 'is-danger': errors[0] }",
                        :message="errors")
                        b-input(v-model="item.description", style="width: 420px")
                ValidationProvider(
                    name="Preis (€)",
                    :rules="{ required: true, currency: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*\.[0-9]{2}$/ }",
                    v-slot="{ errors, valid }")
                    b-field(
                        label="Preis (€)",
                        label-position="on-border",
                        :type="{ 'is-danger': errors[0] }",
                        :message="errors")
                        b-input(
                            :value="(item.price / 100).toFixed(2)",
                            @input="(e) => updatePrice(e.toString().replace(',', '.') * 100, item.count, item)",
                            style="width: 100px")
                ValidationProvider(
                    name="inkl. MwSt.",
                    rules="required",
                    v-slot="{ errors, valid }")
                    b-field(
                        label="inkl. MwSt.",
                        label-position="on-border",
                        :type="{ 'is-danger': errors[0] }",
                        :message="errors")
                        b-input(v-model="item.taxPercentage", style="width: 100px")
                b-field(label="Gesamtpreis", label-position="on-border")
                    b-input(
                        disabled,
                        :value="(item.totalPrice / 100).toFixed(2)",
                        style="width: 120px")
                .spacer.sm
                b-button(type="is-danger", @click="formData.items.splice(index, 1)") Löschen

        b-button(type="is-primary", icon-left="plus", @click="addnewItemRow") Neuer Eintrag
        .spacer.sm.inline
        b-button(type="is-light", icon-left="silverware", @click="showMenu = true") Menü öffnen

        .spacer.md
        .label Anhang zur Rechnung
        .file-upload-button
            b-field(v-if="formData.pdfAttachment === null")
                b-upload(
                    v-model="formData.pdfAttachment",
                    drag-drop="",
                    accept="application/pdf")
                    section.section
                        .content.has-text-centered
                            p PDF zur Rechnung hinzufügen
            b-button(
                v-else,
                icon-left="close",
                @click="formData.pdfAttachment = null") {{ formData.pdfAttachment.name }} entfernen

        .button-wrapper.margin-top.right
            b-button(type="is-light", @click="") Abbrechen
            b-button(
                type="is-primary",
                :disabled="(activeTab === 0 && selectedOwners.length === 0) || (activeTab === 1 && selectedCustomer === null)"
                @click="(formDataArray.length >= 1 || formData.ownerId) && handleSubmit(invoicePreview)") Rechnungsvorschau

    // Here comes the modal for the menu
    b-modal(
        v-model="showMenu",
        has-modal-card,
        :full-screen="false",
        :can-cancel="true")
        .modal-card(style="width: auto") 
            header.modal-card-head
                p.modal-card-title Beispiel Rechnungseinträge
            section.modal-card-body
                b-table(:data="exampleMenu", default-sort-direction="asc")
                    b-table-column(field="description", label="Code", v-slot="props")
                        | {{ props.row.description }}
                    b-table-column(label="Aktionen", v-slot="props")
                        .button-wrapper
                            b-button(
                                type="is-primary",
                                @click="formData.items.push(props.row)") Einfügen

    // Here comes the modal for selecting a booking in case an owner has multiple
    b-modal(
        v-model="showBookingSelectionModal",
        has-modal-card,
        :full-screen="false",
        :can-cancel="true")
        .modal-card(style="width: auto") 
            header.modal-card-head
                p.modal-card-title Buchungsauswahl als Referenz für die Rechnung
            section.modal-card-body
                b-table(:data="tempCustomer ? tempCustomer.rentObjectBookings : []", default-sort-direction="asc")
                    b-table-column(field="bookingStatus.name", label="Status", v-slot="props")
                        | {{ props.row.bookingStatus.name }}
                    b-table-column(field="rentObject.name", label="Name", v-slot="props")
                        | {{ props.row.rentObject.name }}
                    b-table-column(label="Zeitraum", v-slot="props")
                        | {{ new Date(props.row.startDate).toLocaleDateString("de-DE", dateOptions) }} - {{ new Date(props.row.endDate).toLocaleDateString("de-DE", dateOptions) }}
                    b-table-column(label="Aktionen", v-slot="props")
                        .button-wrapper
                            b-button(
                                type="is-primary",
                                @click="createCustomerFormDataArray(props.row)") Auswählen
</template>

<script>
import SendFinanceInvoiceModal from "@/components/molecules/SendFinanceInvoiceModal.vue";
import BookingCustomer from "@/components/molecules/BookingCustomer.vue";
import { generateOwnerName } from '@/store/modules/emailTemplates.js';

export default {
    components: {
        BookingCustomer,
        SendFinanceInvoiceModal,
    },
    props: {
        owners: {
            type: Array,
            default: () => [],
        },
        rentObjects: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            activeTab: 0,
            showBookingSelectionModal: false,
            showSendFinanceInvoiceModal: false,
            showMenu: false,
            searchResults: [],
            selectedOwners: [],
            selectedCustomer: null,
            searchString: "",
            formDataArray: [],
            tempCustomer: null,
            formData: {
                description: "",
                invoiceDate: new Date(),
                pdfAttachment: null,
                totalPrice: 10000,
                items: [
                    {
                        count: 1,
                        unit: "Std.",
                        description: "Kosten für die Verwaltung",
                        price: 10000,
                        taxPercentage: 19,
                        totalTax: 1900,
                        totalPrice: 10000,
                    },
                ],
            },
            exampleMenu: [
                {
                    count: 1,
                    unit: "Stück",
                    description: "Geschirrspültabs und Salz",
                    price: 10000,
                    taxPercentage: 19,
                    totalTax: 1900,
                    totalPrice: 10000,
                },
                {
                    count: 3,
                    unit: "Stunden",
                    description: "Grundreinigung",
                    price: 10000,
                    taxPercentage: 19,
                    totalTax: 1900,
                    totalPrice: 10000,
                },
            ],
            dateOptions: {
                year: "2-digit",
                month: "2-digit",
                day: "2-digit"
            },
        };
    },
    watch: {
        searchString() {
            this.selectedCustomer = null;
            this.updateSearch();
        },
        selectedOwners() {
            this.createOwnerFormDataArray();
        },
        selectedCustomer() {
            this.createCustomerFormDataArray();
        },
        activeTab(newVal) {
            if (newVal === 0) {
                this.createOwnerFormDataArray();
                this.formData.ownerId = null;
            }
        },
        priceItem: {
            deep: true,
            handler() {
                this.formData.totalPrice = this.formData.items.reduce((acc, item) => {
                    return acc + item.totalPrice;
                }, 0);
            }
        },
    },
    computed: {
        fileAttachment() {
            return this.formData.pdfAttachment;
        },
        priceItem() {
            return this.formData.items;
        },
    },
    methods: {
        cleanFormData() {
            this.formData = {
                description: this.formData.description,
                invoiceDate: this.formData.invoiceDate,
                pdfAttachment: this.formData.pdfAttachment,
                totalPrice: this.formData.totalPrice,
                items: this.formData.items
            }
        },
        createOwnerFormDataArray() {
            this.selectedCustomer = null;
            this.cleanFormData();
            this.formDataArray = [];
            for (let i = 0; this.selectedOwners.length > i; i += 1) {
                const owner = this.selectedOwners[i];

                const newOwnerInvoice = {
                    ...owner,
                    ownerId: owner.id,
                    customerId: null,
                    rentObjectBookingId: null,
                    fullName: owner.fullName,
                    noTax: owner.noTax,
                    title: '',
                    salutation: '',
                    firstName: '',
                    lastName: generateOwnerName(owner),
                    address: owner.address,
                    type: "financeInvoice-owner",
                    rentObjectIds: [],
                };
                this.formDataArray.push(newOwnerInvoice);
            }
        },
        async createCustomerFormDataArray(bookingSelected) {
            this.cleanFormData();
            if (this.selectedCustomer === null) return;
            if (bookingSelected) {
                this.formData.rentObjectBookingId = bookingSelected.id;
                this.formData.rentObjectBooking = bookingSelected;
                this.showBookingSelectionModal = false;

                const owner = this.owners.find(o => {
                    const rentObject = o.rentObjects.find(r => r.id === bookingSelected.rentObjectId);
                    return !!rentObject;
                })

                this.formData = {
                    ...this.formData,
                    ownerId: owner.id,
                    fullName: owner.fullName,
                    noTax: owner.noTax,
                    title: '',
                    salutation: '',
                    firstName: '',
                    lastName: generateOwnerName(owner),
                    address: owner.address,
                };

                return; // this is the last step as the user has selected a booking
            }

            this.tempCustomer = null;
            const customer = await this.$store.dispatch("customers/findOne", { id: this.selectedCustomer.id });

            // The customer must have made a booking otherwise we can't create an invoice
            if (!customer.rentObjectBookings || customer.rentObjectBookings.length === 0) {
                alert("Dieser Kunde hat noch keine Buchung gemacht. Darum kann auch keine Rechnung im Namen eines Eigentümers erstellt werden.");
                return;
            }

            const owner = this.owners.find(o => {
                const rentObject = o.rentObjects.find(r => r.id === customer.rentObjectBookings[0].rentObjectId);
                return !!rentObject;
            })

            this.formData = {
                ...this.formData,
                ownerId: owner.id,
                customerId: customer.id,
                customer: customer,
                rentObjectBookingId: customer.rentObjectBookings[customer.rentObjectBookings.length - 1].id,
                fullName: owner.fullName,
                noTax: owner.noTax,
                title: '',
                salutation: '',
                firstName: '',
                lastName: generateOwnerName(owner),
                address: owner.address,
                type: "financeInvoice-customer"
            };

            if (customer.rentObjectBookings.length > 1) {
                this.tempCustomer = customer;
                this.showBookingSelectionModal = true;
            }
        },
        async updateSearch() {
            this.searchResults = await this.$store.dispatch("customers/search", {
                searchString: this.searchString,
            });
        },
        addnewItemRow() {
            this.formData.items.push({
                count: 1,
                unit: "",
                description: "",
                price: 10000,
                taxPercentage: 19,
                totalTax: 1900,
                totalPrice: 10000,
            });
        },
        updatePrice(centPrice, count, item) {
            item.count = count;
            item.price = centPrice;
            item.totalTax = Math.round((centPrice * item.taxPercentage) / 100);
            item.totalPrice = centPrice * count;
        },
        calculateItem(item) {
            if (item.quantity > 0 && item.price !== "") {
                const centPrice = parseInt(
                    item.price.toString().replace(",", ".") * 100
                );
                return item.quantity * (centPrice / 100).toFixed(2);
            }
            return 0;
        },
        invoicePreview() {
            this.showSendFinanceInvoiceModal = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.overflow-y {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    border: solid 1px $lightgray;
    border-radius: 3px;
}

.invoice-field-group {
    display: flex;
    flex-direction: space-between;
}

.file-upload-button {
    // opacity: 0.4;
    margin-right: $sm-space;

    p {
        font-size: 12px;
    }
}
</style>